import React,{ useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import projectsInfo from '../ProjectsInfo';
import { NavBar } from '../../../utility/navBar/Navbar';
import './DetailedProjectPage.css';

// Project info component for detailed project page
const ProjectInfo = ({ id, title, date, address, style }) => {
    return (
        <div className="project-info">

            <div className='project-info__title-container'>
                <div className='project-info__title'>
                    <p>{id > 10 ? '' : 0}{id}.</p>
                    <h1 >{title}</h1>
                </div>
            </div>

            <div className='project-info__details'>
                <i>
                    <p>Date: {date}</p>
                    <p>Address: {address}</p>
                    <p>Style: {style}</p>
                </i>
            </div>
        </div>
    );
};

// Color palette component for detailed project page
const ColorPalette = ({ colors }) => {
    return (
        <div className="color-palette">
            {colors.map((color, index) => (
                <div key={index} className="color-swatch" style={{ backgroundColor: color }}></div>
            ))}
        </div>
    );
};

// Content element component for detailed project page
const ContentElement = ({ type, content }) => {
    switch (type) {
        case 'largeImage':
            return (
                <div className="large-image">
                    <img src={require(`../../../assets/img/${content}`)} alt="detailed-project__large-image"  />
                </div>
            );
            
            
        case 'sideBySideImages':
            return (
                <div className="side-by-side-images">
                    {content.map((src, index) => (
                        <img key={index} src= {require(`../../../assets/img/${src}`)} alt={`Side by side ${index}`} />
                    ))}
                </div>
            );
        case 'paragraph':
            return (
                <div className="paragraphs">
                    {content.map((paragraph, index) => (
                        <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }}></p>
                    ))}
                </div>);
        default:
            return null;
    }
};

// Back link component for detailed project page
const BackLink = () => {
    return (
        <div className="back-link">
            <Link to="/projects">
                <p>&lt;Back to Past Projects</p>
            </Link>
        </div>
    );
}


// Detailed project page component
export const DetailedProjectPage = () => {
    const { projectId } = useParams();
    const project = projectsInfo.find(p => p.id === parseInt(projectId));

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo({ top: 0, left: 0});
    }, []);

    if (!project) {
        return <div>Project not found</div>;
    }

    return (
        <div className="detailed-project-page">
            <NavBar theme='dark' />
            <BackLink />
            <ProjectInfo
                id={project.id}
                title={project.name}
                date={project.date}
                address={project.address}
                style={project.style}
            />
            <ColorPalette colors={project.colors} />
            <div className="content-elements">
                {project.content.map((element, index) => (
                    <ContentElement key={index} type={element.type} content={element.content} />
                ))}
            </div>
        </div>
    );
};